import {
	Button,
	HStack,
	Input,
	Text,
} from '@montel/montelpro-shared-components-v2';
import { RequestStatus } from '@montel/montelpro-shared-components/enums';
import { SUBSCRIPTIONS_API_ROUTE } from 'apiRoutes';
import useSubmit, { POST } from 'hooks/useSubmit';
import { FunctionComponent, useState } from 'react';

const AssignSeatTool: FunctionComponent = () => {
	const [subscriberId, setSubscriberId] = useState<string>('');
	const [subscriptionId, setSubScriptionId] = useState<number>();

	const [submit, status] = useSubmit(
		`${SUBSCRIPTIONS_API_ROUTE}/AssignSeat`,
		POST,
		{
			messageOnSuccess: 'User successfully assigned to seat',
			messageOnError: 'Error assigning seat',
			showApiError: true,
		},
	);

	const onSubmit = async () => {
		await submit({
			subscriberId: subscriberId,
			subscriptionId: subscriptionId,
		});
	};

	return (
		<>
			<Text>Assign Seat</Text>
			<HStack wrap="nowrap">
				<Input
					label="Account id"
					type="text"
					autoComplete="off"
					name="accountId"
					value={subscriberId}
					required
					onChange={(event) => setSubscriberId(event.target.value)}
				/>
				<Input
					label="Subscription id"
					type="number"
					autoComplete="off"
					name="subscriptionId"
					value={subscriptionId}
					required
					onChange={(event) => setSubScriptionId(event.target.value)}
				/>
			</HStack>
			<Button
				onClick={onSubmit}
				type="submit"
				text="Assign seat"
				loadingText="Assigning seat ..."
				isLoading={status === RequestStatus.LOADING}
			/>
		</>
	);
};

export default AssignSeatTool;
